<template lang="pug">
  #deals-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-storekeepers-freights" md-label="Грузы" v-bind:to="{ name: 'StorekeepersFreights'}")
      md-tab(id="tab-storekeepers-itineraries" md-label="Маршрутные листы" v-bind:to="{ name: 'StorekeepersItineraries'}")
</template>

<script>
  export default {
    name: 'storekeepers-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// storekeepers-menu.vue?46ba560c